import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, mappingResultError, NotFoundError, Result, UseCase } from '@digibricks/core';
import { NoneValue } from '../../../../core';
export var MOVE_HEADING_USE_CASE = 'MOVE_HEADING_USE_CASE';

/**
 * Persist heading reorder with PATCH /forms/:formId/headings/:id/move.
 *
 * Callers should pass headings whose previous/next heading + question links already
 * match the new interleaved order (see syncHeadingLinksFromInterleavedList).
 * Patching only the moved heading's neighbors is not enough — stale nextQuestionId
 * pointers on siblings cause Headings.sortWithQuestions to drop questions.
 */
export var MoveHeadingUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(MoveHeadingUseCase, _UseCase);

  var _super = _createSuper(MoveHeadingUseCase);

  function MoveHeadingUseCase(formRepository) {
    var _this;

    _classCallCheck(this, MoveHeadingUseCase);

    _this = _super.call(this);
    _this.formRepository = formRepository;
    return _this;
  }

  _createClass(MoveHeadingUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var headingId, formId, rawPreviousHeadingId, previousQuestionId, nextQuestionId, nextHeadingId, sectionId, headings, previousHeadingId, workingHeadings, moved, targetSectionId, resolvedPreviousQuestionId, resolvedNextQuestionId, resolvedNextHeadingId, existingHead, dto, apiOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headingId = input.headingId, formId = input.formId, rawPreviousHeadingId = input.previousHeadingId, previousQuestionId = input.previousQuestionId, nextQuestionId = input.nextQuestionId, nextHeadingId = input.nextHeadingId, sectionId = input.sectionId, headings = input.headings;
                previousHeadingId = rawPreviousHeadingId === null || rawPreviousHeadingId === void 0 ? void 0 : rawPreviousHeadingId.trim();

                if (previousHeadingId) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", new BadInputError('previousHeadingId is required'));

              case 4:
                if (!(previousHeadingId === headingId)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", new BadInputError('A heading cannot be placed after itself'));

              case 6:
                workingHeadings = headings.map(function (h) {
                  return h.clone();
                });
                moved = workingHeadings.find(function (h) {
                  return h.id.toString() === headingId;
                });

                if (moved) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", new NotFoundError('Heading is not existed'));

              case 10:
                targetSectionId = (sectionId === null || sectionId === void 0 ? void 0 : sectionId.trim()) || moved.sectionId;
                resolvedPreviousQuestionId = (previousQuestionId === null || previousQuestionId === void 0 ? void 0 : previousQuestionId.trim()) || NoneValue;
                resolvedNextQuestionId = (nextQuestionId === null || nextQuestionId === void 0 ? void 0 : nextQuestionId.trim()) || NoneValue;
                resolvedNextHeadingId = (nextHeadingId === null || nextHeadingId === void 0 ? void 0 : nextHeadingId.trim()) || NoneValue; // Becoming section head without nextHeadingId would leave two heads.

                if (previousHeadingId === NoneValue && resolvedNextHeadingId === NoneValue) {
                  existingHead = workingHeadings.find(function (h) {
                    return h.id.toString() !== headingId && h.sectionId === targetSectionId && h.previousHeadingId === NoneValue;
                  });

                  if (existingHead) {
                    resolvedNextHeadingId = existingHead.id.toString();
                    moved.updateNextHeadingId(resolvedNextHeadingId);
                    existingHead.updatePreviousHeadingId(headingId);
                  }
                } // Keep the moved heading in sync with the dto (idempotent when headings were pre-synced).


                if (moved.sectionId !== targetSectionId) {
                  moved.updateSectionId(targetSectionId);
                }

                moved.updatePreviousHeadingId(previousHeadingId);
                moved.updateNextHeadingId(resolvedNextHeadingId);
                moved.updatePreviousQuestionId(resolvedPreviousQuestionId);
                moved.updateNextQuestionId(resolvedNextQuestionId);
                dto = _objectSpread({
                  previousHeadingId: previousHeadingId,
                  previousQuestionId: resolvedPreviousQuestionId,
                  nextQuestionId: resolvedNextQuestionId,
                  nextHeadingId: resolvedNextHeadingId
                }, sectionId ? {
                  sectionId: targetSectionId
                } : {});
                _context.next = 23;
                return this.formRepository.moveHeading(formId, headingId, dto);

              case 23:
                apiOrError = _context.sent;

                if (!apiOrError.isFailure) {
                  _context.next = 26;
                  break;
                }

                return _context.abrupt("return", mappingResultError(apiOrError));

              case 26:
                return _context.abrupt("return", Result.ok({
                  movedHeading: moved,
                  headings: workingHeadings
                }));

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return MoveHeadingUseCase;
}(UseCase);